<template>
  <div class="cp-shop-manager-app main">
    <div class="divider" />

    <div class="row" @click="gotoAppURL">
      <p>
        <i class="fa fa-download icon" />Get the App
        <i
          class="fa fa-external-link-alt has-text-link is-pulled-right"
          style="padding: 4px"
        />
      </p>
    </div>

    <div class="divider" />

    <div
      class="row"
      @click="goto('/commerce_page/set-app-icon?app=shop_manager')"
    >
      <p>
        <i class="far fa-user-circle icon" />App Icon
        <i v-if="loadingIcon" class="fa fa-spinner fa-spin" />
      </p>
      <p class="app-icon">
        <img :src="appIcon" @load="loadingIcon = false" />
        <img :src="appIcon" class="round" />
      </p>
    </div>

    <div class="divider" />

    <div class="row" @click="goto('commerce_page/set-theme-color')">
      <p><i class="fa fa-palette icon" />Theme Color</p>
      <div v-if="themeColor" class="theme-color" :style="themeColor" />
      <div v-else class="value">
        <i class="far fa-edit has-text-info" />&nbsp;Set Theme Color
      </div>
    </div>

    <div style="height: 60px" />
  </div>
</template>


<script>
export default {
  name: "CPShopManagerApp",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      loadingIcon: true,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    themeColor() {
      if (!this.business.data.theme_color) return null;
      return `background-color: ${this.business.data.theme_color}`;
    },
    shopStyle() {
      if (!this.commerce.data.menu_style) return null;
      return this.capitaliseFirstLetter(this.commerce.data.menu_style);
    },
    appData() {
      return this.business.data.shop_manager_app;
    },
    appIcon() {
      var placeholder = "https://via.placeholder.com/200?text=Not Set";
      if (!this.appData) return placeholder;
      return this.appData.icon_192 || placeholder;
    },
  },
  methods: {
    gotoAppURL() {
      window.open("https://manager-thedukes.sabai.app", "_blank");
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  border-bottom: 1px dotted rgb(230, 230, 230);
}
.fa-plus-circle {
  color: #ddd;
}
.app-icon {
  margin-left: 32px;
  margin-top: 10px;
}
.app-icon img {
  display: inline-block;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  height: 90px;
  width: 90px;
  margin-right: 20px;
  object-fit: cover;
  border-radius: 20%;
  background-color: #ccc;
}
.round {
  border-radius: 100px !important;
}
.banner img {
  object-fit: cover;
  height: 100px;
  width: 100%;
  margin-top: 10px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.14);
}
.theme-color {
  height: 30px;
  border-radius: 2px;
  margin-left: 32px;
  margin-top: 4px;
  margin-bottom: 4px;
  box-shadow: 0 0 1px 1px lightgrey;
}
.todo .row {
  background-color: #eef;
}
</style>
